import React, { useState, useEffect } from "react";
import { Route } from "react-router-dom";
import { BrowserRouter } from "react-router-dom";
import { Routes } from "react-router-dom";
import JsonData from "./data/data.json";

import "./App.css";
import { ThemeProvider } from "./context/ThemeContext";
import { useDocumentLang } from "./hooks/useDocumentLang";
import Landing from "./components/landing";
import Formsend from "./components/formsend";
import { Navigation } from "./components/navigation";
import { Contact } from "./components/contact";
import Message from "./components/message";
import Account from "./components/account";
import ForuJob from "./components/forujob";
import Foru from "./components/foru";
import ContratoPF from "./components/contratopf";
import ContratoPJ from "./components/contratopj";
import SecurityCiber from "./components/securityCiber";
import SecurityDados from "./components/securityDados";
import SecurityUses from "./components/securityUses";
import Ouvidoria from "./components/ouvidoria";
import Garantias from "./components/garantias";
import { AccountCancellation } from "./components/AccountCancellation";

const AppRoutes = () => {
  const [landingPageData, setLandingPageData] = useState({});

  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  return (
    <>
      <Navigation data={landingPageData.Contact} />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/workforus" element={<Formsend />} />
        <Route path="/message" element={<Message />} />
        <Route path="/account" element={<Account />} />
        <Route path="/forujob" element={<ForuJob />} />
        <Route path="/foru" element={<Foru />} />
        <Route path="/contratoPF" element={<ContratoPF />} />
        <Route path="/contratoPJ" element={<ContratoPJ />} />
        <Route path="/ciber-security" element={<SecurityCiber />} />
        <Route path="/dados-security" element={<SecurityDados />} />
        <Route path="/uses-security" element={<SecurityUses />} />
        <Route path="/ouvidoria" element={<Ouvidoria />} />
        <Route path="/garantias" element={<Garantias />} />
        <Route path="/cancelamento-de-conta" element={<AccountCancellation />} />
      </Routes>
      <Contact data={landingPageData.Contact} />
    </>
  );
};

const App = () => {
  useDocumentLang();

  return (
    <div id="rootApp">
      <BrowserRouter>
        <ThemeProvider>
          <AppRoutes />
        </ThemeProvider>
      </BrowserRouter>
    </div>
  );
};

export default App;
